import { EventConstantsInterface } from './types';

export enum EventConstantEnums {
  SHOW_TOAST,
  HIDE_TOAST,
  SHOW_MODAL,
  HIDE_MODAL,
  SHOW_SIDEDRAWER,
  HIDE_SIDEDRAWER,
  SHOW_CIRCULAR_PROGRESS,
  HIDE_CIRCULAR_PROGRESS,
  SHOW_GLOBAL_ACTIONS_POPOVER,
  HIDE_GLOBAL_ACTIONS_POPOVER,
}

export const EventConstants: EventConstantsInterface = {
  SHOW_TOAST: 'SHOW_TOAST',
  HIDE_TOAST: 'HIDE_TOAST',
  SHOW_MODAL: 'SHOW_MODAL',
  HIDE_MODAL: 'HIDE_MODAL',
  SHOW_SIDEDRAWER: 'SHOW_SIDEDRAWER',
  HIDE_SIDEDRAWER: 'HIDE_SIDEDRAWER',
  SHOW_CIRCULAR_PROGRESS: 'SHOW_CIRCULAR_PROGRESS',
  HIDE_CIRCULAR_PROGRESS: 'HIDE_CIRCULAR_PROGRESS',
  SHOW_GLOBAL_ACTIONS_POPOVER: 'SHOW_GLOBAL_ACTIONS_POPOVER',
  HIDE_GLOBAL_ACTIONS_POPOVER: 'HIDE_GLOBAL_ACTIONS_POPOVER',
};
